export class RoutingUrl {
    public static PROPERTY_LISTING = '/property/property-listing';
    public static PROPERTY_SUBMENU = '/property/property-submenu';

    public static ANNOUNCEMENT_LISTING = '/news/announcement-listing';
    public static ANNOUNCEMENT_EDITOR_ADD = '/news/announcement/add';
    public static ANNOUNCEMENT_EDITOR_EDIT = '/news/announcement/edit';

    public static TODO_LISTING = '/todo/todo-listing';
    public static BOOKING_DETAILS = '/todo/booking-details';
    public static BRAND_ALLOCATION_DETAILS = '/todo/brand-allocation-details';
    public static RENTAL_CONTRACT_DETAILS = '/todo/rental-contract-details';
    public static LEASING_POLICY_APPROVAL_DETAILS = '/todo/leasing-policy-approval-details';
    public static RENOVATION_ADMINISTRATION_DETAILS = '/todo/renovation-administration-details';
    public static NOTIFICATION_LISTING = '/notifications/notification-listing';
    public static BUSINESS_INSIGHT_LISTING = '/business-insight/business-insight-listing';
    public static EVENT_MANAGEMENT_DETAILS = '/todo/event-management-details';
    public static SERVICEREQUEST_LISTING = '/service-request/service-request-listing';
    public static SERVICEREQUEST_ADD = '/service-request/add-service-request';
    public static SERVICEREQUEST_ACTIVITIES = '/service-request/service-request-activities';
    public static SERVICEREQUEST_DETAILS = '/service-request/service-request-details';
    public static SERVICEREQUEST_QUOTATION = '/service-request/service-request-quotation';
    public static SERVICEREQUEST_SUBHEADER = '/service-request/service-request-subheader';
    public static PRICING_POLICY_APPROVAL_DETAILS = '/todo/pricing-policy-approval-details';
    public static REVENUE_TARGETING_POLICY_APPROVAL_DETAILS = '/todo/revenue-targeting-policy-approval-details';
    public static BRAND_ALLOC_DURING_OPS_DETAILS = '/todo/brand-alloc-during-ops-details';
    public static TENANT_MIX_DETAILS = '/todo/tenant-mix-details';
    public static BRAND_ALLOC_DURING_PREP_DETAILS = '/todo/brand-alloc-during-prep-details';
    public static RENT_REVIEW_DETAILS = '/todo/rent-review-details';
    public static CONTRACT_CLOSURE_DETAILS = '/todo/contract-closure-details';
    public static BILL_ADJUSTMENT_DETAILS = '/todo/bill-adjustment-details';
    public static REBATE_APPROVAL_DETAILS = '/todo/rebate-approval-details';
    public static REFUND_REQUISITION_DETAILS = '/todo/refund-requisition-details';

    public static AGEING_ANALYSIS = '/business-insight/ageing-analysis';
    public static BOOKING_STATISTICS = '/business-insight/booking-statistics';
    public static OCCUPANCY_STATISTIC = '/business-insight/occupancy-statistic';
    public static CONTRACTS_AND_OPPORTUNITIES = '/business-insight/contracts-and-opportunities';
    public static OCCUPANCY_PROJECTION = '/business-insight/occupancy-projection';
    public static RENTAL_INCOME_PROJECTION = '/business-insight/rental-income-projection';
    public static TENANT_SALES_COLLECTION_ANALYSIS = '/business-insight/tenant-sales-collection-analysis';
    public static TOP_10_RENTAL_CONTRIBUTOR = '/business-insight/top-ten-rental-contributor';
    public static TOP_10_OUTSTANDING = '/business-insight/top-ten-outstanding';
    public static OPPORTUNITY_ANALYSIS_REPORT = '/business-insight/opportunity-analysis-report';
    public static ACTIVE_CONTRACT_REPORT = '/business-insight/active-contract-report';
    public static EXPIRING_CONTRACT_REPORT = '/business-insight/expiring-contract-report';
    public static DAILY_SALES_SUBMISSION_REPORT = '/business-insight/daily-sales-submission-report';
    public static SERVICE_REQUEST_REPORT = '/business-insight/service-request-report';
    public static SERVICE_REQUEST_BI = '/business-insight/service-request-report-bi';
    public static BUSINESS_INSIGHT_OCCUPANCY_STATISTICS = '/business-insight/business-insight-occupancy-statistics';
    public static CONTRACTS_AND_OPPORTUNITIES_TABLE = '/business-insight/contracts-and-opportunities-table';
    public static TENANT_PAYMENT_TRANSACTIONS = '/business-insight/tenant-payment-transactions';
    public static SERVICE_REQUEST_BY_ASSIGNEE = '/business-insight/service-request-by-assignee';
    public static SERVICE_REQUEST_BY_MONTH = '/business-insight/service-request-by-month';

    public static LISTING_TEMPLATE = '/template/listing-template';

    public static LOGIN = '/authentication/login';
    public static FORGOT_PASSWORD = '/authentication/forgot';
    public static HOME = '/';
}
